const validStatusCode = [200, 204]

export default {
  isSuccess(statusCode) {
    return validStatusCode.includes(statusCode)
  }
}
